import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import moment from 'moment'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  Select as AntdSelect, message, Dropdown, Button as AntButton, Icon, Menu, DatePicker, Modal, Checkbox,
} from 'antd'
import { Mutation } from 'react-apollo'
import {
  Select, SmallText, Div, Loading, Button as KonsysButton, Input, P as KonsysP,
} from 'konsys-ui'
import { Link } from 'react-router-dom'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText, truckType } from '../../pages/truckowner-page/constants'
import { P } from '../../pages/truckowner-page/styled'
import { UPDATE_TRUCK_OWNER } from '../../constants/graphql/mutation'
import PERMISSION from '../../constants/permissions'
import { checkFloat, monthConverter } from '../../utils/util-services'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const CellText = props => (
  <P font='sarabun'>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const StatusSelector = ({
  statusAttr, handleChange, filter, disabled,
}) => {
  const [value, setValue] = useState(statusAttr)
  const arr = [
    { value: status.AVAILABLE, text: statusText.AVAILABLE },
    { value: status.REPAIRING, text: statusText.REPAIRING },
    { value: status.OUT_OF_SERVICE, text: statusText.OUT_OF_SERVICE },
  ]

  return (
    <Select
      disabled={disabled}
      dropdown
      data={
        filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr
      }
      onChange={(e) => {
        setValue(e.text)
        handleChange(e.value)
      }}
      buttonProps={{
        width: '150px',
        text: value || '-',
        ghost: true,
        small: true,
        // margin: '-5px 0 0 0',
      }}
    />
  )
}

export const TypeSelector = ({
  handleChange,
}) => {
  const arr = _.concat([{ value: 'ALL', text: 'ทั้งหมด' }], truckType)
  return (
    <AntdSelect
      dropdown
      defaultValue='ทั้งหมด'
      style={{ width: '120px' }}
      onChange={(e) => {
        handleChange(e)
      }}
    >
    {
      arr.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)}>
        <Link target="_blank" to={`/truckowner/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_TRUCK)}>
        <Link target="_blank" to={`/truckowner/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <AntButton>
      ดูรายละเอียด <Icon type="down" />
    </AntButton>
  </Dropdown>
)

// export const ActionSelector = ({ disabled, props }) => {
//   const arr = [
//     { value: 'view', text: 'ดูรายละเอียด' },
//     { value: 'edit', text: 'แก้ไข' },
//   ]
//   return <AntdSelect
//     disabled={disabled}
//     dropdown
//     maxHeight="none"
//     defaultValue='ดูรายละเอียด'
//     style={{ width: 120 }}
//     onSelect={e => history.push(`/truckowner/${e}/${props.original.id}`)}
//     >
//     {
//       arr.map(v => <AntdSelect.Option key={v.value} value={v.value}><Link to={`/truckowner/${v.value}/${props.original.id}`}>{v.text}</Link></AntdSelect.Option>)
//     }
//   </AntdSelect>
// }

export const Wrapper = props => (
  <Div
    display='block'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const TruckOwnerStatusCeil = ({ disabled, props, refetch }) => {
  const [value, setValue] = useState(statusText[props.value])
  const arr = [
    { value: status.AVAILABLE, text: statusText.AVAILABLE },
    { value: status.REPAIRING, text: statusText.REPAIRING },
    { value: status.OUT_OF_SERVICE, text: statusText.OUT_OF_SERVICE },
  ]
  return (
    <Mutation
        mutation={UPDATE_TRUCK_OWNER}
      >
      {(doUpdateTruckOwner, { loading }) => {
        if (loading) return <Loading/>
        return (
        <Div>
          <AntdSelect
            value={value}
            disabled={disabled}
            dropdown
            maxHeight="none"
            style={{
              backgroundColor: '#00000000',
              width: '150px',
            }}
            onChange={(e) => {
              setValue(statusText[e])
              doUpdateTruckOwner({
                variables: {
                  id: props.original.id,
                  status: e,
                },
              }).then((resp) => {
                const response = resp.data.UpdateTruckowner
                if (response.success) {
                  message.success(response.message)
                  refetch()
                } else message.error(response.message)
              })
            }}
          >
          {
            arr.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
          }
          </AntdSelect>
        </Div>
        )
      }}
    </Mutation>
  )
}

export const ExpenseModal = ({
  modal, setModal, isLoading, setIsLoading, truckownerid, data,
}) => {
  const [mutationVariables, setMutationVariables] = useState({
    truckOwnerId: truckownerid,
    pricePerTon: 0,
    social: 0,
    gps: 0,
    withHoldingTax: 0,
    difference: 0,
    mechFee: 0,
    licenseFee: 0,
    insuranceFee: 0,
    etcFee: 0,
    sealFee: 0,
    tireFee: 0,
    rimFee: 0,
    partFee: 0,
    outsideRepairFee: 0,
  })
  const [show, setShow] = useState(['withHoldingTax', 'difference'])
  const [date, setDate] = useState()
  const ExpenseList = [
    { text: 'ราคา / ตัน', value: 'pricePerTon' },
    { text: 'ค่าประกันสังคม', value: 'social' },
    { text: 'ค่า GPS', value: 'gps' },
    { text: 'ค่าหัก ณ ที่จ่าย', value: 'withHoldingTax' },
    { text: 'ค่าหักน้ำหนักขาดเกิน', value: 'difference' },
    { text: 'ค่าช่าง', value: 'mechFee' },
    { text: 'ค่าต่อทะเบียน', value: 'licenseFee' },
    { text: 'ค่าต่อประกันและพรบ.', value: 'insuranceFee' },
    { text: 'ค่าใช้จ่ายเบ็ดเตล็ด', value: 'etcFee' },
    { text: 'ค่าซีล', value: 'sealFee' },
    { text: 'ค่ายาง', value: 'tireFee' },
    { text: 'ค่ากะทะล้อ', value: 'rimFee' },
    { text: 'ค่าอะไหล่', value: 'partFee' },
    { text: 'บิลซ่อมรถนอกบริษัท', value: 'outsideRepairFee' },
  ]

  useEffect(() => {
    if (data) {
      setMutationVariables({
        truckOwnerId: truckownerid,
        pricePerTon: data.pricePerTon ? data.pricePerTon : 0,
        social: data.social,
        gps: data.gps,
        withHoldingTax: data.withHoldingTax,
        difference: data.difference,
        mechFee: data.mechFee,
        licenseFee: data.licenseFee,
        insuranceFee: data.insuranceFee,
        etcFee: data.etcFee,
        sealFee: data.sealFee,
        tireFee: data.tireFee,
        rimFee: data.rimFee,
        partFee: data.partFee,
        outsideRepairFee: data.outsideRepairFee,
      })
      setShow(data.show.split(','))
      setDate(moment(data.startDate))
    }
  }, [data])

  const download = () => {
    const inputArray = [
      `truckOwnerId=${mutationVariables.truckOwnerId}`,
      `pricePerTon=${_.indexOf(show, 'pricePerTon') > -1 ? mutationVariables.pricePerTon : undefined}`,
      `social=${mutationVariables.social}`,
      `gps=${mutationVariables.gps}`,
      `withHoldingTax=${mutationVariables.withHoldingTax}`,
      `difference=${mutationVariables.difference}`,
      `mechFee=${mutationVariables.mechFee}`,
      `licenseFee=${mutationVariables.licenseFee}`,
      `insuranceFee=${mutationVariables.insuranceFee}`,
      `etcFee=${mutationVariables.etcFee}`,
      `sealFee=${mutationVariables.sealFee}`,
      `tireFee=${mutationVariables.tireFee}`,
      `rimFee=${mutationVariables.rimFee}`,
      `partFee=${mutationVariables.partFee}`,
      `outsideRepairFee=${mutationVariables.outsideRepairFee}`,
      `show=${show.join(',')}`,
      `startDate=${moment(date).startOf('month').format('YYYY-MM-DD')}`,
      `endDate=${moment(date).endOf('month').format('YYYY-MM-DD')}`,
      `t=${getAccessToken()}`,
    ].join('&')
    window.open(
      `${getURL().FILE_SERVER}/download/pdf/truckowner/?${inputArray}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading(false)
  }

  const onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: parseFloat(value),
    })
  }

  return (
    <Modal
      title="เลือกวันที่"
      visible={modal}
      destroyOnClose={true}
      onCancel={() => {
        setModal(false)
        setDate()
        setShow(['withHoldingTax', 'difference'])
        setMutationVariables({
          truckOwnerId: truckownerid,
          pricePerTon: 0,
          social: 0,
          gps: 0,
          withHoldingTax: 0,
          difference: 0,
          mechFee: 0,
          licenseFee: 0,
          insuranceFee: 0,
          etcFee: 0,
          sealFee: 0,
          tireFee: 0,
          rimFee: 0,
          partFee: 0,
          outsideRepairFee: 0,
        })
      }}
      onOk={() => {
        setIsLoading(true)
        download()
      }}
      okButtonProps={{
        disabled: _.isUndefined(date) || isLoading,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <DatePicker.MonthPicker
          value={date || undefined}
          format='YYYY-MM'
          onChange={(e) => {
            setDate(e)
          }}
          style={{ width: '50%' }}
        />
        <Div textAlign='center' margin='8px 0'>
          {
            _.map(ExpenseList, v => (
              <Div display='flex' flexDirection='row' justifyContent='space-between' margin='8px 0'>
                <Checkbox
                  disabled={_.isUndefined(date)}
                  key={v.value}
                  checked={_.includes(show, v.value)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setShow(_.concat(show, v.value))
                    } else {
                      setShow(_.remove(_.cloneDeep(show), n => n !== v.value))
                    }
                  }}
                  style={{ margin: '8px 16px 0 0' }}
                />
                <P margin='8px 0'>{v.text}</P>
                <Input
                  width='100%'
                  type='number'
                  step={0.1}
                  min={0}
                  disabled={_.isUndefined(date)}
                  value={mutationVariables[v.value]}
                  onKeyDown={(e) => {
                    if (!checkFloat(e)) {
                      e.preventDefault()
                    }
                  }}
                  onChange={e => onChangeHandler(v.value, e.target.value)}
                />
              </Div>
            ))
          }
        </Div>
      </Div>
    </Modal>
  )
}

export const PrintLogList = ({ data }) => {
  const [modal, setModal] = useState(false)
  const [detail, setDetail] = useState()
  const [isLoading, setIsLoading] = useState(false)
  if (data.TruckOwnerReportLogsList.lists.length === 0) return null
  return (
    <Wrapper>
      <P margin='8px 0'>ประวัติการพิมพ์รายงานสรุปยอดรถร่วม</P>
      {
        data.TruckOwnerReportLogsList.lists.map((v, index) => (
          <Div display='flex' key={index} flexDirection='row' margin='8px 0'>
            <P margin='8px 0' style={{ cursor: 'pointer' }} color='green' onClick={() => {
              setDetail(v)
              setModal(true)
            }}>{index + 1}. รายงานตั้งแต่วันที่ {moment(v.startDate).format('DD-MM-YYYY')} ถึงวันที่ {moment(v.endDate).format('DD-MM-YYYY')} พิมพ์เมื่อวันที่ {moment(v.createdAt).format('DD-MM-YYYY')} </P>
          </Div>
        ))
      }
      <ExpenseModal modal={modal} setModal={setModal} isLoading={isLoading} setIsLoading={setIsLoading} truckownerid={data.TruckOwnerReportLogsList.lists[0].truckOwnerId} data={detail}/>
    </Wrapper>
  )
}

const RepairExpenseModal = ({
  repairExpenseModal, setRepairExpenseModal, isLoading, setIsLoading, props, pdfInfo,
}) => {
  const [range, setRange] = useState([])
  return (
    <Modal
      title="พิมพ์รายงานค่าใช้จ่ายของการซ่อมรถบรรทุก"
      visible={repairExpenseModal}
      destroyOnClose={true}
      onCancel={() => {
        setRepairExpenseModal(false)
        setRange([])
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/truck/expenseByOwner?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `truckOwnerId=${props.match.params.id}`,
            ].join('&')
          }`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์รายงานค่าใช้จ่ายการซ่อมรถบรรทุกวันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} ของ ${pdfInfo.nameTh}.xlsx`)
          setIsLoading(false)
          setRepairExpenseModal(false)
          setRange([])
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(range),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row'>
        <KonsysP margin = '0 32px 0 0'>เลือกวันที่</KonsysP>
        <DatePicker.RangePicker
          format='DD/MM/YYYY'
          onChange={(e) => {
            setRange(e)
          }}
        />
      </Div>
    </Modal>
  )
}

const TireExpenseModal = ({
  tireExpenseModal, setTireExpenseModal, isLoading, setIsLoading, props, pdfInfo,
}) => {
  const [range, setRange] = useState([])
  return (
    <Modal
      title="พิมพ์รายงานค่ายาง"
      visible={tireExpenseModal}
      destroyOnClose={true}
      onCancel={() => {
        setTireExpenseModal(false)
        setRange([])
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/truck/tire/expenseByOwner?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
              `truckOwnerId=${props.match.params.id}`,
            ].join('&')
          }`,
        }).then((resp) => {
          FileDownload(resp.data, `พิมพ์รายงานค่ายางวันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} ของ ${pdfInfo.nameTh}.xlsx`)
          setIsLoading(false)
          setTireExpenseModal(false)
          setRange([])
        })
      }}
      okButtonProps={{
        disabled: isLoading || _.isUndefined(range),
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row'>
        <KonsysP margin = '0 32px 0 0'>เลือกวันที่</KonsysP>
        <DatePicker.RangePicker
          format='DD/MM/YYYY'
          onChange={(e) => {
            setRange(e)
          }}
        />
      </Div>
    </Modal>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, pdfInfo,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [tireExpenseModal, setTireExpenseModal] = useState(false)
  const [repairExpenseModal, setRepairExpenseModal] = useState(false)
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton disabled={isAddMode} margin='0 0' text='พิมพ์ค่าใช้จ่ายการซ่อมรถบรรทุก' icon='fas fa-print' onClick={() => setRepairExpenseModal(true)} />
      <KonsysButton disabled={isAddMode} margin='0 16px 0 16px' text='พิมพ์รายงานค่ายาง' icon='fas fa-print' onClick={() => setTireExpenseModal(true)} />
      <KonsysButton
        text='พิมพ์สรุปยอดรถร่วม'
        icon='fas fa-print'
        margin='0 8px'
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_TRUCK)) || isAddMode}
        onClick={() => setModal(true)}
      />
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_TRUCK)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/truckowner/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateTruckowner : data.UpdateTruckowner
              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/truckowner')
                // else history.push(`/truckowner/view/${props.match.params.id}`)
              } else message.error(resp.message)
            })
          }
        }}
      />
      <RepairExpenseModal
        repairExpenseModal={repairExpenseModal}
        setRepairExpenseModal={setRepairExpenseModal}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        props={props}
        pdfInfo={pdfInfo}
        />
        <TireExpenseModal
        tireExpenseModal={tireExpenseModal}
        setTireExpenseModal={setTireExpenseModal}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        props={props}
        pdfInfo={pdfInfo}
        />
      <ExpenseModal modal={modal} setModal={setModal} isLoading={isLoading} setIsLoading={setIsLoading} truckownerid={props.match.params.id}/>
    </Div>
  )
}
